import React from 'react';

const LogoLoader = ({ 
  size = 'md', 
  text = 'Loading...', 
  fullScreen = false,
  className = '' 
}) => {
  const sizeClasses = {
    sm: 'w-12 h-12',
    md: 'w-16 h-16',
    lg: 'w-24 h-24',
    xl: 'w-32 h-32'
  };

  const textSizeClasses = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base',
    xl: 'text-lg'
  };

  const loader = (
    <div className={`flex flex-col items-center justify-center gap-3 ${className}`}>
      <div className="relative">
        {/* Pulsing ring animation */}
        <div className={`absolute inset-0 ${sizeClasses[size]} rounded-full bg-amber-500/20 animate-ping`} />
        <div className={`absolute inset-0 ${sizeClasses[size]} rounded-full bg-amber-500/10 animate-pulse`} />
        
        {/* Logo with bounce animation */}
        <img 
          src="/logo.png" 
          alt="Loading" 
          className={`${sizeClasses[size]} relative z-10 animate-bounce`}
          style={{ animationDuration: '1s' }}
        />
      </div>
      
      {text && (
        <p className={`${textSizeClasses[size]} text-secondary font-medium animate-pulse`}>
          {text}
        </p>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-50 flex items-center justify-center">
        {loader}
      </div>
    );
  }

  return loader;
};

export default LogoLoader;
